<script lang="ts">
  import type { DebtorData as OldDebtorData } from "../../../../apis/parkito";
  import type { DebtorData, SwedishId } from "../../../../apis/parkito2";
  import DebtorEdit from "./DebtorEdit.svelte";
  import CustomButton from "../../../../shared/components/CustomButton.svelte";
  import { Toast } from "$components";
  import { Form, FormInput } from "../../../../shared/lib/validation_next";
  import ValInputField from "../../../../shared/components/ValInputField.svelte";
  import ValCheckbox from "../../../../shared/components/ValCheckbox.svelte";
  import Separator from "../../../../shared/components/Separator.svelte";
  import ValSelect from "../../../../shared/components/ValSelect.svelte";
  import type { Readable } from "svelte/store";

  export let requestClose: (() => void) | null;
  export let debtorData: DebtorData | null;
  export let submitForm: ((params: DebtorData) => void) | null = null;
  export let buttonsInvisible: boolean = false;

  export let debtorOutput: FormInput<DebtorData | OldDebtorData> = Form
    .input();
  const requestFormSubmit = async () => {
    if (!$debtorOutput.res.isOk()) {
      Toast.error("Formuläret innehåller fel");
      return;
    }
    const formValue = $debtorOutput.res.value;
    if (submitForm) {
      submitForm(formValue);
    }
  };
</script>

<DebtorEdit
  debtor={debtorOutput}
  buttonInvisible={true}
></DebtorEdit>

{#if !buttonsInvisible}
  <div class="flex pt-[24px] justify-end">
    {#if requestClose}
      <CustomButton
        type="ghost"
        onClick={requestClose}
        customClass="mr-[8px] {debtorData ? '!hidden' : null}"
      >Avbryt</CustomButton>
    {/if}

    <CustomButton
      disabled={!($debtorOutput.res.isOk() && $debtorOutput.hasChanged)}
      type="primary"
      onClick={requestFormSubmit}
      customClass="w-[200px] {debtorData ? '!w-full !max-w-full' : null}"
    >Lägg till</CustomButton>
  </div>
{/if}
